import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../../auth/auth.service';
import { APP_ROUTES } from '../../routing.const';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  readonly authSvc = inject(AuthService);
  readonly router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.#isAuthorized(state);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.#isAuthorized(state);
  }

  #isAuthorized(state: RouterStateSnapshot) {
    return this.authSvc.loading$.pipe(
      filter((v) => !v),
      take(1),
      map(() => {
        if (this.authSvc.isAuthorize()) {
          return true;
        }

        return this.router.createUrlTree([
          APP_ROUTES.UNAUTHORIZED,
          {
            redirectUrl: state.url,
          },
        ]);
      }),
    );
  }
}
